import { OrderDetail } from '@insurance/api/requests'
import { createContext, useContext } from 'react'

type PropertyInsuranceValues = {
  isEditable: boolean
  order?: OrderDetail
}

const PropertyInsuranceContext = createContext<PropertyInsuranceValues>({
  isEditable: false
})

export const PropertyInsuranceProvider = ({
  children,
  ...values
}: React.PropsWithChildren<PropertyInsuranceValues>) => {
  return (
    <PropertyInsuranceContext.Provider value={values}>
      {children}
    </PropertyInsuranceContext.Provider>
  )
}

export const usePropertyInsuranceValues = () =>
  useContext(PropertyInsuranceContext)
